import EditIcon from './component'

export default EditIcon
